import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  content: {
    minWidth: 500,
  },
  btUpload: {
    marginLeft: theme.spacing(1),
  },
  dropzone: {
    border: '2px dashed #ccc',
    borderRadius: 4,
    padding: theme.spacing(2),
    textAlign: 'center',
    cursor: 'pointer',
    marginBottom: theme.spacing(2),
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  dropzoneActive: {
    borderColor: theme.palette.primary.main,
  },
  fileList: {
    marginTop: theme.spacing(2),
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    border: '1px solid #eee',
    borderRadius: 4,
  },
  fileInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  fileIcon: {
    marginRight: theme.spacing(1),
  },
  fileName: {
    marginRight: theme.spacing(1),
  },
  fileSize: {
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
  },
  errorText: {
    color: theme.palette.error.main,
  },
  uploadProgress: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
}));
